// List workflows
import './list/create-template';
import './list/view-template';

// Details workflows
import './details/archive-template';
import './details/delete-template';
import './details/duplicate-template';
import './details/fix-template';
import './details/restore-template';
import './details/send-template';



// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/workflows.js